import ValidityHelper from '../../../../Helpers/ValidityHelper';
import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import PaymentInformationValidationItem from './PaymentInformationValidationItem';
import PaymentExportAllExportService from '../../../../Services/PaymentExportAllExportService';

export default class PaymentInformationValidationWindowDescription {
  static titleForCreate = 'Validate Payment Information';
  static titleForEdit = 'Validate Payment Information';
  static finishButtonLabel = 'Validate';
  static itemType = PaymentInformationValidationItem;
  static serviceFunction = (edited) => PaymentExportAllExportService.postValidatePaymentInformationFile(edited);
  static waitForServiceFunction = () => false;
  static messageOnSuccess =
    'The validation has been started. You will receive a notification about the result in your personal notification repository.';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'file',
          label: 'Payment Export Summary File',
          className: 'col-12',
          type: InputTypesEnum.FileUploadField,
          acceptedTypes: '.xlsx, .xls, .csv',
          validityChecker: ValidityHelper.forRequiredFileField,
        },
      ],
    },
  ];
}
